import axios from 'axios'
import {toData} from "./util";

export function getSetting(key): Promise {
  return axios.get(`/api/settings/${key}`).then(toData)
}
